declare global {
  interface Window {
    env: any;
  }
}

export const env = { ...process.env, ...window["env"] };